export default __webpack_public_path__ + "static/media/10.697e3ff0.jpg";